import React from 'react';

const WrongRoute = () => {
    return (
        <div>
            Wrong Route
        </div>
    );
};

export default WrongRoute;